<template>
  <div class="treatments">
    <div class="row list no-gutters">
      <div class="item item-last col">
        <a class="py-2 px-3"
          ><strong class="mr-2">{{ $t("drugs") }}</strong></a
        >
      </div>
    </div>
    <table class="table table-hover table-bordered">
      <tbody>
        <tr v-for="v in treatmentDrugs(value)" :key="`treatment-${v.id}`">
          <td :class="{ cancelled: v.cancelled_at }">
            {{ v.data.name }}
          </td>
          <td :class="{ cancelled: v.cancelled_at }">
            {{ v.data.instruction }}
          </td>
          <td
            v-if="!v.cancelled_at && authType === 'Doctor'"
            class="text-center"
          >
            <a class="pointer text-nowrap" @click.prevent="cancelDrug(v.id)">
              <span class="text-primary">
                <remove-icon></remove-icon>
              </span>
            </a>
          </td>
          <td v-if="v.cancelled_at" class="text-center">
            <small class="text-muted">
              {{ $t("cancelled") }}
              {{ v.cancelled_at | moment("from", "now") }}
            </small>
          </td>
        </tr>
      </tbody>
      <tfoot v-if="authType === 'Doctor'">
        <tr>
          <td>
            <label class="w-100">
              <div class="pb-2">{{ $t("drugName") }}</div>
              <textarea
                type="text"
                name="name"
                class="w-100"
                v-model="name"
              ></textarea>
            </label>
          </td>
          <td>
            <label class="w-100">
              <div class="pb-2">{{ $t("druginstruction") }}</div>
              <textarea
                type="text"
                name="instruction"
                class="w-100"
                v-model="instruction"
              ></textarea>
            </label>
          </td>
          <td class="text-center">
            <button type="button" class="btn btn-primary" @click="createDrug">
              <plus-icon></plus-icon>
            </button>
          </td>
        </tr>
      </tfoot>
    </table>
    <div class="row list no-gutters">
      <div class="item item-last col">
        <a class="py-2 px-3"
          ><strong class="mr-2">{{ $t("recommendations") }}</strong></a
        >
      </div>
    </div>
    <div
      v-for="v in treatmentRecommendations(value)"
      :key="`treatment-${v.id}`"
      class="row list no-gutters"
    >
      <template v-if="v.type === 'Recommendation'">
        <div class="col item item-last" :class="{ cancelled: v.cancelled_at }">
          <a class="py-2 px-3" v-if="v.id">
            {{ v.data.text }}
          </a>
        </div>
        <div
          class="col-auto item item-last"
          v-if="!v.cancelled_at && authType === 'Doctor'"
        >
          <a
            class="py-2 px-3 pointer"
            @click.prevent="cancelRecommendation(v.id)"
          >
            <span class="text-primary">
              <remove-icon></remove-icon>
            </span>
          </a>
        </div>
      </template>
    </div>
    <div v-if="authType === 'Doctor'">
      <div class="row list no-gutters border-bottom">
        <div class="item col item-last">
          <label class="py-2 px-5 m-0">
            <div class="pb-2">{{ $t("recommendation") }}</div>
            <textarea
              type="text"
              class="w-100 h-100"
              v-model="recommendation"
            ></textarea>
          </label>
          <button
            type="submit"
            class="btn btn-primary"
            @click="createRecommendation"
          >
            {{ $t("addRecommendation") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import PlusIcon from '@/components/Icons/Plus'
import RemoveIcon from '@/components/Icons/Remove'
export default {
  components: {
    RemoveIcon,
    PlusIcon
  },
  props: {
    value: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      recommendation: null,
      name: null,
      instruction: null
    }
  },
  computed: {
    ...mapGetters({
      authLocale: 'auth/locale',
      authType: 'auth/type',
      treatments: 'pcase/treatments',
      caseById: 'pcase/byId',
      treatmentDrugs: 'pcase/treatmentDrugs',
      treatmentRecommendations: 'pcase/treatmentRecommendations'
    }),
    pcase () {
      return this.caseById(this.value)
    }
  },
  methods: {
    ...mapMutations({
      setError: 'alert/setError',
      setTreatment: 'pcase/setTreatment'
    }),
    async createDrug () {
      try {
        const params = { name: this.name, instruction: this.instruction }
        const response = await this.axios.post(
          `/api/patient-cases/${this.value}/treatment/drugs`,
          params
        )
        this.reset()
        this.setTreatment({ id: this.value, treatment: response.data.data })
      } catch (err) {
        this.setError(err)
      }
    },
    async createRecommendation () {
      try {
        const params = { text: this.recommendation }
        const response = await this.axios.post(
          `/api/patient-cases/${this.value}/treatment/recommendations`,
          params
        )
        this.reset()
        this.setTreatment({ id: this.value, treatment: response.data.data })
      } catch (err) {
        this.setError(err)
      }
    },
    async cancelRecommendation (id) {
      try {
        const response = await this.axios.put(
          `/api/patient-cases/${this.value}/treatment/recommendations/${id}/cancel`
        )
        this.setTreatment({ id: this.value, treatment: response.data.data })
      } catch (err) {
        this.setError(err)
      }
    },
    async cancelDrug (id) {
      try {
        const response = await this.axios.put(
          `/api/patient-cases/${this.value}/treatment/drugs/${id}/cancel`
        )
        this.setTreatment({ id: this.value, treatment: response.data.data })
      } catch (err) {
        this.setError(err)
      }
    },
    reset () {
      this.recommendation = null
      this.name = null
      this.instruction = null
    }
  }
}
</script>
<style lang="scss">
.treatments {
  .table {
    svg {
      width: 24px;
    }
  }
  .cancelled {
    text-decoration: line-through;
  }
}
</style>
<i18n>
{
  "ka": {
    "createRecommendation": "რეკომენდაციის მიცემა",
    "createDrug": "მედიკამენტის დანიშვნა",
    "recommendation": "რეკომენდაცია",
    "drugName": "მედიკამენტის დასახელება",
    "druginstruction": "მიღების წესი",
    "addDrug": "დანიშვნა",
    "addRecommendation": "გამოქვეყნება",
    "cancel": "გაუქმება",
    "drugs": "მედიკამენტები",
    "recommendations": "რეკომენდაციები",
    "cancelled": "გაუქმდა"
  },
  "en": {
    "createRecommendation": "Add Recommendation",
    "createDrug": "Add Drug Treatment",
    "recommendation": "Recommendation",
    "drugName": "Drug Name",
    "druginstruction": "Instructions for Drug",
    "addDrug": "Add Drug",
    "addRecommendation": "Publish Recomendation",
    "cancel": "Cancel",
    "drugs": "Drugs",
    "recommendations": "Recommendations",
    "cancelled": "Canceled"
  }
}
</i18n>
